import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// @mui
import Box from '@mui/material/Box';
import { Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getHistory, getMobile, togglePage } from 'state/reducers/ui.reducers';
import { pagesEnum } from 'constants/ui.constants';
import _ from 'lodash';
import { getLangAsync } from 'state/reducers/translation.reducers';

interface Props {
	title: string;
	text?: string;
	subtext?: string;
}

interface PropsChildren {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
}

export function HeaderPage1(props: Props) {
	const hasTextProp = props.text && props.text.length;
	const hasSubTextProp = props.subtext && props.subtext.length;
	return (
		<Box>
			<Typography variant="h3">{props.title}</Typography>
			{hasTextProp ? <Typography variant="body1">{props.text}</Typography> : null}
			{hasSubTextProp ? <Typography variant="body1">{props.subtext}</Typography> : null}
		</Box>
	);
}

export function HeaderPage2(props: Props) {
	return (
		<Box className="HeaderPage2">
			<Typography variant="h4">{props.title}</Typography>
		</Box>
	);
}

export function HeaderPage3(props: Props) {
	const hasTextProp = props.text && props.text.length;
	return (
		<Box>
			<Typography variant="subtitle2">{props.title}</Typography>
			{/* TODO: understand how to use custom typography theme. (suppose to be subtitle2_faded) */}
			{hasTextProp ? <Typography variant="subtitle2">{props.text}</Typography> : null}
		</Box>
	);
}
//use with image above as brand message
export function HeaderPage4(props: Props) {
	const theme = useTheme();
	const hasTextProp = props.text && props.text.length;
	return (
		<Stack>
			<Typography color={theme.palette.root.basicDeepBlue} variant="boldBody18">
				{props.title}
			</Typography>
			{/* TODO: understand how to use custom typography theme. (suppose to be subtitle2_faded) */}
			{hasTextProp ? (
				<Typography color={theme.palette.root.basicDeepBlue} variant="body3">
					{props.text}
				</Typography>
			) : null}
		</Stack>
	);
}

export function FormHeader1(props: Props) {
	return (
		<Box>
			<Typography variant="h3">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
}

export function FormHeadWithCheckbox(props: PropsChildren) {
	const theme = useTheme();
	return (
		<Grid
			className="FormHeadWithCheckbox"
			flexDirection="row"
			container
			display="flex"
			columnGap={theme.spacing(2)}
			sx={{ '& .Mui-checked:after': { borderWidth: '0!important' } }}
		>
			<Stack direction="row" spacing={2} flexGrow={1}>
				{props.children}
			</Stack>
		</Grid>
	);
}

export function HeaderCaption1(props: Props) {
	//title and text are the same font
	const hasTextProp = props.text && props.text.length;
	return (
		<Box>
			<Typography variant="boldBody1">{props.title}</Typography>
			{hasTextProp ? <Typography variant="body1">{props.text}</Typography> : null}
		</Box>
	);
}

export function NavigationBack() {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const history = useAppSelector(getHistory);
	const isMobile = useAppSelector(getMobile);
	const language = useAppSelector((state) => state.translation.language);
	let goBack = getUrlBack(location.pathname, history[history.length - 1]);

	const props = {
		onClick: () => {
			dispatch(togglePage(goBack));
		},
		sx: {
			color: '#000',
			cursor: 'pointer',
			width: isMobile ? '16px' : 'initial',
			transform: language === 'he' ? 'scaleX(-1)' : '',
		},
	};
	return isMobile ? <ArrowBackIosIcon width={'16px'} {...props} /> : <ArrowBack {...props} />;
}

export function getUrlBack(from: string, to: string) {
	let goBack = to;
	const bnUrl = `/${pagesEnum.BENEFICIARY}`;
	const reqUrl = `/${pagesEnum.REQUEST}`;
	const payUrl = `/${pagesEnum.PAY}`;
	if (goBack.match(`${bnUrl}/new`) || goBack.match(`${bnUrl}/edit`) || goBack.match(`${bnUrl}/details`)) {
		if (from.match(`${bnUrl}/details`)) {
			goBack = bnUrl;
		}
		if (from.match(`${reqUrl}/requestDetailsPY`) || from.match(`${reqUrl}/new`)) {
			goBack = reqUrl;
		}
		if (from.match(`${payUrl}/new`)) {
			goBack = '/';
		}
	}
	if (_.includes([from, `/${pagesEnum.PAY}`, `/${pagesEnum.CONVERT}`], goBack)) {
		goBack = '/';
	}
	return goBack;
}
